'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import { useDetachNewEntriesMutation } from '@/hooks/useDetachNewEntriesMutation';
import type { SurveyHome } from '@/models/survey';
import { useMainStore } from '@/store';
import { SURVEY_STATUS, type SurveyStatus } from '@/utils/constants';
export const useSurveyRowAction = () => {
  const $ = _c(11);
  const router = useRouter();
  const {
    currentUser
  } = useMainStore();
  const detachNewEntriesMutation = useDetachNewEntriesMutation();
  const shouldDetachNewEntries = _temp;
  let t0;
  if ($[0] !== currentUser?.id || $[1] !== detachNewEntriesMutation) {
    t0 = surveyId => {
      detachNewEntriesMutation.mutate({
        surveyId,
        userId: currentUser?.id ?? ""
      });
    };
    $[0] = currentUser?.id;
    $[1] = detachNewEntriesMutation;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  currentUser?.id;
  const handleDetachNewEntries = t0;
  let t1;
  if ($[3] !== handleDetachNewEntries || $[4] !== router) {
    t1 = t2 => {
      const {
        survey,
        currentUserId
      } = t2;
      const url = `/survey?type=${survey.type.slug}&sId=${survey.id}&page=intro`;
      if (survey.gates?.authorizedToUpdate) {
        if (shouldDetachNewEntries(survey.status?.label) && currentUserId) {
          handleDetachNewEntries(survey.id);
        }
        router.push(url);
      } else {
        if (survey.gates?.authorizedToView) {
          router.push(url);
        }
      }
    };
    $[3] = handleDetachNewEntries;
    $[4] = router;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const navigateToSurvey = t1;
  let t2;
  if ($[6] !== currentUser?.id || $[7] !== navigateToSurvey) {
    t2 = (key, surveys) => {
      const survey_1 = surveys?.find(survey_0 => survey_0.id === key);
      if (!survey_1) {
        return;
      }
      navigateToSurvey({
        survey: survey_1,
        currentUserId: currentUser?.id
      });
    };
    $[6] = currentUser?.id;
    $[7] = navigateToSurvey;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  currentUser?.id;
  const handleSurveyRowAction = t2;
  let t3;
  if ($[9] !== handleSurveyRowAction) {
    t3 = {
      handleSurveyRowAction
    };
    $[9] = handleSurveyRowAction;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
function _temp(status) {
  const DETACHABLE_STATUSES = [SURVEY_STATUS.OPEN, SURVEY_STATUS.PAUSED, SURVEY_STATUS.CLOSED];
  return status !== undefined && DETACHABLE_STATUSES.includes(status);
}